// CAL-1 — a tiny "open the calendar popup" bus, mirroring features/mira/miraIntentBus verbatim.
// The full /calendar page is retired: the popup (CalendarLauncher) IS the calendar. Any surface —
// the teacher avatar menu, the Home week-strip link, the /calendar route alias — asks the launcher
// to open without knowing where it lives. A launcher that isn't mounted yet simply doesn't hear it
// (the route alias also carries ?calendar=open for the cross-navigation case, so no signal is lost).
const listeners = new Set();

export function onCalendarOpen(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestCalendarOpen() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      /* swallow — a launcher not mounted yet simply doesn't hear it */
    }
  });
}
